import { extendedfooterRender } from "./templates/renders/extendedfooter";

const ExtendedFooter: any = {
	tagName: "extended-footer",
	initialize(options) {
		initComponent(options);
	},
	renderer: extendedfooterRender,
	onIconClick(e) {
		if (typeof e.currentTarget.onIconClick !== "undefined") {
			e.currentTarget.onIconClick(e);
		}
	},
};

export default (appInstance) => {
	ExtendedFooter.$app = appInstance;
	return ExtendedFooter;
};

const initComponent = (options: any) => {
	const appInstance = options.$app;
	const footerConfig = appInstance.getUIConfig().footerConfig || {};

	options.constants = {
		extendStyle: footerConfig.extendedFooterStyles,
		extendItemStyle: footerConfig.extendedFooterItemStyles,
		config: footerConfig.footerSettings || {},
	};
};
